import styled, { css } from 'styled-components';

export const KebabWrapper = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.icon.neutral.strong};

    fuel-dropdown {
      width: min-content;
    }
  `}
`;

export const DropdownContent = styled.div`
  ${({ theme }) => css`
    width: 312px;
    padding: 0 ${theme.spacing.km2};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.km2};
  `}
`;
